// extracted by mini-css-extract-plugin
module.exports = {"image":"product-only-delivery_image___E5f_","imageContainer":"product-only-delivery_imageContainer__SVwjx"};